/* eslint-disable jira/filename-case */
import { IS_MODERN_SSR } from './constants.tsx';

export function getIsModernSsr(): boolean {
	return IS_MODERN_SSR;
}
